
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FuseCardComponent } from '@fuse/components/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgFor, NgIf, NgClass, CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IResponse, ITicketTopics } from 'app/core/shared-services/shared-interface.types';
import Swal from 'sweetalert2';
import { MatSelectModule } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { InnerHTMLPipe } from "../../core/pipes/innerHTML.pipe";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-campaign',
  standalone: true,
  imports: [
    MatSlideToggleModule, MatBadgeModule, FuseCardComponent, MatButtonModule, MatFormFieldModule, ReactiveFormsModule,
    FormsModule, NgIf, MatInputModule, FooterComponent, MatIconModule, SharedMethodsModule, MatSelectModule, NgFor,
    NgClass, RouterLink, MatProgressSpinnerModule, CommonModule,
    InnerHTMLPipe
],
  templateUrl: './campaign.component.html',
 
})


export class CampaignComponent {
  @ViewChild('createTicketDialog') createTicketDialog!: TemplateRef<any>;
  @ViewChild('completionTemplate') completionTemplate!: TemplateRef<any>;
  createTicketDialogRef!: MatDialogRef<any>;
  completionTemplateRef!: MatDialogRef<any>;
  public campaignInfo = <any>Array;
  public accountForm: UntypedFormGroup;
  public name: any;
  public surname: any;
  public email: any;
  public phoneNumber: any;
  public idNumber: any;
  public showModal: boolean;
  public address: any;
  public ticketTopicsResult: ITicketTopics[] = [];
  public relocateObj: ITicketTopics;
  public ticketForm: FormGroup;

  private manualIdChange:boolean = false;
  private postalCode: string;
  private province: string;
  private streetAddress: string;
  private country: string;
  private unitNumber: string;
  private customerAccount: any;
  private ticketTopics: any; 
  private dialog = inject(MatDialog); 
  private topic:string = '';
  private topicId:number = 0; 
  private loading: boolean;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private strapiService: StrapiService,
    private _sharedMethods: SharedMethodsModule,
    private breakpointObserver: BreakpointObserver
  ) {

    this.accountForm = this.formBuilder.group({
        name: [this.name],
        surname: [this.surname],
        email: [this.email],
        phoneNumber: [this.phoneNumber],
        idNumber: [this.idNumber],
        address: [this.address]
      });
      
    this.ticketForm = this.formBuilder.group({
        Subject: ["ID NUMBER CHANGE"],
        Description: ["I NEED TO CHANGE MY ID NUMBER TO:"],
        TopicId: [this.topicId],
        Topic: [this.topic]
      });
  }

  ngOnInit() {
    this.getCampaign();
    this.getAccount();
    this.getTicketTopics();
  }

  getCampaign() {
      this.strapiService.getCampaign().subscribe({
        next:(res: any)=>{
          this.campaignInfo = res?.data;
       
        },
        error:()=>{

        }
      })
  }

  async getAccount(){
    this.customerAccount = await this._sharedMethods.getCustomerAccount();
    this.customerAccount = this.customerAccount.result;

    // if (customerAccount) {
    //   accountId = this.customerAccount?.EntityAccountEntityID;
    //   const id : string = this.customerAccount?.IDNumber;
    //   this.displayedIdNumber = id?.substring(0,6) + '*******';
    // }

    this.accountForm.patchValue({
      name: this.customerAccount?.PrimaryContactName,
      surname: this.customerAccount?.PrimaryContactLastName,
      email: this.customerAccount?.PrimaryContactEmail,
      phoneNumber: this.customerAccount?.PrimaryContactMobile,
      idNumber: this.customerAccount?.IDNumber,
      address: this.customerAccount?.PhysicalAddressLine2
    });
  }


initAutocomplete(input: HTMLInputElement) {
  const autocomplete = new google.maps.places.Autocomplete(input, {
    types: ['address'],
    componentRestrictions: { country: 'ZA' },
  });

  autocomplete.addListener('place_changed', () => {
    this.unitNumber = "";
    this.streetAddress = "";
    this.province = "";
    this.country = "";
    this.postalCode = "";
    
    const place = autocomplete.getPlace();
    if (!place.address_components) return;
    for (const component of place.address_components) {
      const types = component.types;
      if (types.includes('subpremise')) {
        this.unitNumber = component.long_name;
      } else if (types.includes('street_number')) {
        this.streetAddress = component.long_name + ' ' + this.streetAddress;
      } else if (types.includes('route')) {
        this.streetAddress += component.long_name;
      } else if (types.includes('administrative_area_level_1')) {
        this.province = component.long_name;
      } else if (types.includes('country')) {
        this.country = component.long_name;
      } else if (types.includes('postal_code')) {
        this.postalCode = component.long_name;
      }
    }

    this.accountForm.patchValue({
      address: place.formatted_address
      });
    });
  }


    public async saveCustomerDetails() {
      if(!this.accountForm.value.idNumber){
        this.dialog.open(this.createTicketDialog);
      }else{
        this.updateProfile();
      }
    }


    private async updateProfile(){
      
      const data = {
        PrimaryContactName          : this.accountForm.value.name,
        PrimaryContactLastName      : this.accountForm.value.surname,
        PrimaryContactEmail         : this.accountForm.value.email,
        PrimaryContactMobile        : this.accountForm.value.phoneNumber,
        IDNumber                    : this.accountForm.value.idNumber,
        PhysicalAddressLine1        : this.unitNumber ?? this.customerAccount.PhysicalAddressLine1,
        PhysicalAddressLine2        : this.streetAddress ?? this.customerAccount.PhysicalAddressLine2,
        PhysicalAddressLine3        : this.province ?? this.customerAccount.PhysicalAddressLine3,
        PhysicalAddressLine4        : this.country ?? this.customerAccount.PhysicalAddressLine4,
        PhysicalAddressPostalCode   : this.postalCode ?? this.customerAccount.PhysicalAddressPostalCode,
        CompetitionMarketingConsent : true
      }

      const updatedObject = {...this.customerAccount, ...data}
  
      await this._sharedMethods.updateCustomerAccount(updatedObject).then((res: IResponse)=>{
        if(res.success){
          Swal.fire({
            timer: 2000,
            toast: false,
            title: 'Congratulations, you have entered!',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
              htmlContainer: 'text-lg',
              confirmButton: 'custom-button text-md',
            }
          });
          this.dialog.closeAll();
        }else{
          Swal.fire({
            title: 'Error!',
            icon: 'error',
            text: 'our details could not be updated, please contact support if this error persists',
            showCancelButton: false,
            confirmButtonText: 'OKAY',
            showConfirmButton: true,
            customClass: {
              htmlContainer: 'text-xl',
              confirmButton: 'custom-button text-lg',
            }
          });
          this.dialog.closeAll();
        }
      });
    }

  public openTicketModal() {
      this.manualIdChange = true;
      this.createTicketDialogRef = this.dialog.open(this.createTicketDialog, {
        width: '500px',
        panelClass  : 'transparent-panel',
        backdropClass: 'blurModalBackground'
      });
    }

   // get Ticket topics
  private async getTicketTopics() { 
    this.ticketTopics = await this._sharedMethods.getTicketTopics();
     this.ticketTopics?.result?.forEach(element => {
      if(element.Name == 'Support'){
        this.topicId = element.Id;
        this.topic = element.Name;
      }
    });

    this.ticketForm.patchValue({ 
        TopicId: this.topicId,
        Topic: this.topic
      });

     

    if (this.ticketTopics.success) {
      this.ticketTopicsResult = this.ticketTopics.result;
    }
  }


    public async submitTicket() {
      this.loading = true;
      const customerData = {
        CustomerEmailAddress: this.customerAccount?.PrimaryContactEmail,
        CustomerMobileNumber: this.customerAccount?.MobileNumber,
        CustomerName: this.customerAccount?.FirstName
      }
      const data = {
        ...this.ticketForm.value, ...customerData
      }
  
      // submit the customer and ticket object to create the ticket
      await this._sharedMethods.createTicket(data).then((res: IResponse) => {
        if (res.success) {
          this.loading = false;
  
         
    
          Swal.fire({
            timer: 3000,
            toast: true,
            position: 'bottom-end',
            title: 'Support ticket logged!',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: false
          });
          if(!this.manualIdChange){
            this.updateProfile();
          }
          this.manualIdChange = false;
          this.createTicketDialogRef.close();
        } else {
          this.loading = false;
          this.manualIdChange = false;
        
          Swal.fire({
            timer: 3000,
            toast: true,
            position: 'bottom-end',
            title: 'Support ticket failed to send!',
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false
          });
  
        }
      });
    }

  update() {
   const isMobile = this.breakpointObserver.isMatched('(max-width: 767px)');
    this.completionTemplateRef = this.dialog.open(this.completionTemplate, {
      width: isMobile ? '90vw' : '700px',
      maxHeight: '90vh', // limits height on mobile & desktop
      height: 'auto',
      panelClass: 'transparent-panel',
      backdropClass: 'blurModalBackground'
    });
  }

  
    
}